export function tryGetFromMaybeError(error: unknown, key: string) {
  try {
    // @ts-expect-error try to get value
    return error[key];
  } catch {
    return;
  }
}
